import { Component, Element, Prop } from '@stencil/core';

@Component({
  tag: 'mama-accordion',
  styleUrl: './mama-accordion.scss',
})
export class MamaAccordion {
  @Element() el!: Element;

  @Prop() firstOpen: false;
  @Prop() keepAllOpen: false;
  children!: HTMLElement[];

  componentDidLoad() {
    this.children = Array.from(this.el.querySelectorAll('mama-collapse')) as HTMLMamaCollapseElement[];

    this.children.map(collapse => collapse.querySelector('.collapse-headline') as HTMLElement).forEach(collapse => collapse.addEventListener('click', this.handleClick));

    if (this.children.length > 0 && this.firstOpen) {
      (this.children[0] as any).setOpen(true);
    }

    if (this.keepAllOpen) {
      this.children.forEach((childNode: HTMLMamaCollapseElement) => childNode.setOpen(true));
    }
  }

  handleClick = (event: Event) => {
    if (this.keepAllOpen) {
      return;
    }
    const collapse = (event.target as HTMLElement).closest('mama-collapse') as HTMLMamaCollapseElement;

    this.children.filter(childNode => childNode !== collapse).forEach((childNode: HTMLMamaCollapseElement) => childNode.setOpen(false));
  };
}
